import { Modal } from "@mui/base";
import { Backdrop, Box } from "@mui/material";
import { Ptag } from "components/core";
import React from "react";
import modalCloseIcon from "../assets/svgs/modalCloseIcon.svg";
import styled from "styled-components";
import {
  ExclusionBtnDark,
  ExclusionBtnWrapper,
  ExclusionInputStyle,
  ModalCloseBtn,
} from "./v1/PlanOverview/styles";
import { Field, Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

const ProductExclusionModal = ({ open, handleOpen, handleClose, setExclusions }) => {
  const handleSubmit = (values) => {
    let uniqueId =
      Date.now().toString(36) + Math.random().toString(36).substring(2);
    let newExclusion = {
      id: uniqueId,
      heading: values.exclusionHeading,
      description: values.exclusionDescription,
      checked: true,
    };
    setExclusions((prevExclusions) => [...prevExclusions, newExclusion]);
    handleClose();
  };

  const validationSchema = Yup.object().shape({
    exclusionDescription: Yup.string().required("Required"),
  });

  const FormikError = styled.div`
    color: #D3301A;
    margin-top: 6px;
    font-size: 12px;
    font-family: "inter";

    ::before {
      content: "*";
      color: #D3301A;
      font-size: 12px;
    }
  `;

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "783px",
            height: "558px",
            bgcolor: "background.paper",
            border: "none",
            borderRadius: "14px",
            p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Ptag fontSize="24px" fontWeight="600" marginBottom="24px">
              Add Exclusion
            </Ptag>

            <ModalCloseBtn onClick={handleClose}>
              <img src={modalCloseIcon} />
            </ModalCloseBtn>
          </Box>
          <div id="modal-modal-description">
            <Formik
              initialValues={{
                exclusionHeading: "",
                exclusionDescription: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form noValidate>
                <Ptag fontSize="14px" marginTop="12px" marginBottom="12px">
                  Exclusion Heading (optional)
                </Ptag>

                <Field
                  name="exclusionHeading"
                  style={ExclusionInputStyle}
                  type="text"
                />

                <Ptag
                  fontSize="14px"
                  marginTop="24px"
                  marginBottom="12px"
                  color="#4A4A4A"
                >
                  Exclusion Description
                </Ptag>
                <Field
                 
                  name="exclusionDescription"
                  style={ExclusionInputStyle}
                  type="text"
                />
                <ErrorMessage name="exclusionDescription" component={FormikError} />

                <ExclusionBtnWrapper>
                  <ExclusionBtnDark type="submit">{"Update"}</ExclusionBtnDark>
                </ExclusionBtnWrapper>
              </Form>
            </Formik>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ProductExclusionModal;
